import { useQuery } from "@tanstack/react-query"
import { ApplicationRolePermissionDetailGet } from "../app/models/ApplicationRolePermission"
import { digitalManagerApi } from "../services/api"

export function useApplicationRolePermissions(applicationId?: string, roleId?: string) {
  const {
    data: applicationRolePermissions = [],
    isLoading: isLoadingApplicationRolePermissions,
  } = useQuery({
    queryKey: ["applicationRolePermissions", applicationId, roleId],
    queryFn: () =>
      digitalManagerApi
        .get<
          ApplicationRolePermissionDetailGet[]
        >(`/applications/${applicationId}/roles/${roleId}/permissions`)
        .then((r) => r.data),
    enabled: !!applicationId && !!roleId,
  })

  return {
    applicationRolePermissions,
    isLoadingApplicationRolePermissions,
  }
}
